// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d561478e","453":"716328a8","732":"ea497f73"}[chunkId] + ".chunk.js";
};